import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import clientApi from '~/clientApi';
import { INVITATIONS_COLLECTION_QUERY_KEY } from '~/queries/keys';

export const useInviteCreator = () => {
  const queryClient = useQueryClient();

  return useMutation<
    AxiosResponse,
    AxiosError,
    { email: string; handle?: string; message?: string },
    Response
  >(
    ({ email, handle, message }) =>
      clientApi.invitations.create({
        email,
        handle,
        pitch: message,
        _isImpersonatingDisabled: true,
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [INVITATIONS_COLLECTION_QUERY_KEY],
        });
      },
    },
  );
};
